document.addEventListener('DOMContentLoaded', () => {
  // Accordion - Apenas um aberto por vez
  const items = document.querySelectorAll('.ec-faq-item');
  const tabs = document.querySelectorAll('.ec-faq-tab[data-section-index]');
  const contents = document.querySelectorAll('.ec-faq-content[data-section-index]');

  const syncSectionHeights = () => {
    tabs.forEach(tab => {
      tab.style.minHeight = '';
    });

    contents.forEach(content => {
      content.style.minHeight = '';
    });

    tabs.forEach(tab => {
      const sectionIndex = tab.dataset.sectionIndex;
      const content = document.querySelector(`.ec-faq-content[data-section-index="${sectionIndex}"]`);

      if (!content) {
        return;
      }

      const tabHeight = tab.offsetHeight;
      const contentHeight = content.offsetHeight;
      const sectionHeight = Math.max(tabHeight, contentHeight);

      tab.style.minHeight = `${sectionHeight}px`;
      content.style.minHeight = `${sectionHeight}px`;
    });
  };
  
  items.forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.hasAttribute('open')) {
        items.forEach(other => {
          if (other !== item && other.hasAttribute('open')) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });

  requestAnimationFrame(syncSectionHeights);
  window.addEventListener('load', syncSectionHeights);
  window.addEventListener('resize', syncSectionHeights);
});